import {Expressions} from '@packages/systems/wfdl';
import type {Expression} from '@packages/systems/wfdl-ast';
import {getDynamoBindingPaths} from './getDynamoBindingPaths';

export function isDynamoChildrenBinding(expression: Expression): boolean {
  const bindings = Expressions.getRecord(expression);
  if (!bindings || !bindings.children) {
    return false;
  }
  const dynamoBindingPaths = getDynamoBindingPaths(bindings.children);
  return dynamoBindingPaths.length === 1;
}
